var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconSortAsce = function SvgIconSortAsce(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    fillRule: "evenodd",
    d: "M5.602 2.759a.438.438 0 0 1-.31.747H3.98v8.75a.437.437 0 0 1-.437.437h-.875a.438.438 0 0 1-.438-.437v-8.75H.918a.438.438 0 0 1-.309-.747L2.796.571c.17-.17.448-.17.618 0l2.188 2.188zm1.854-.05h7.111a.437.437 0 0 0 .445-.429v-.857a.437.437 0 0 0-.445-.429H7.456a.436.436 0 0 0-.444.429v.857c0 .237.198.429.444.429zm-.444 3c0 .236.198.428.444.428h5.333a.437.437 0 0 0 .445-.428v-.858a.437.437 0 0 0-.445-.428H7.456a.436.436 0 0 0-.444.428v.858zm0 6.857c0 .236.198.428.444.428h1.778a.437.437 0 0 0 .444-.428v-.857a.437.437 0 0 0-.444-.429H7.456a.436.436 0 0 0-.444.429v.857zm0-3.429c0 .237.198.429.444.429h3.556a.437.437 0 0 0 .444-.429V8.28a.437.437 0 0 0-.444-.429H7.456a.436.436 0 0 0-.444.429v.857z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconSortAsce, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-sort-asce.a17407d7.svg";
export { ForwardRef as ReactComponent };